import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import WarningIcon from '@material-ui/icons/Warning';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import { Typography } from '@material-ui/core';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const useStyles = makeStyles(theme => ({
  success: {
    backgroundColor: green[500],
    width: '100%',
  },
  error: {
    width: '100%',
    backgroundColor: theme.palette.error.main,
  },
  info: {
    width: '100%',
    backgroundColor: theme.palette.primary.main,
  },
  warning: {
    width: '100%',
    backgroundColor: amber[800],
  },
  iconVariant: {
    fontSize: 20,
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

const Notification = ({
  variant, message, autoHideDuration, className, show, props,
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(true);

  function handleClose(event, reason) {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  }

  function onClose() {
    setOpen(false);
  }

  const Icon = variantIcon[variant];
  let mymessage = message;
  if (mymessage.length > 50) mymessage = `${mymessage.substring(0, 50)}...`;
  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={show || open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      className={className}
      {...props}
    >
      <SnackbarContent
        className={classes[variant]}
        aria-describedby="client-snackbar"
        message={(
          <Typography id="client-snackbar" className={classes.message}>
            <Icon className={classes.iconVariant} />
            {mymessage}
          </Typography>
        )}
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>,
        ]}
        onClose={handleClose}
      />
    </Snackbar>
  );
};

Notification.propTypes = {
  /** Variant of notification */
  variant: PropTypes.oneOf(['success', 'warning', 'error', 'info']).isRequired,
  /** Message to be displayed */
  message: PropTypes.node,
  /** Hide duration in milliseconds */
  autoHideDuration: PropTypes.number,
  /** Set show/hide manually */
  show: PropTypes.bool,
  /** Custom styling */
  className: PropTypes.string,
  /** Other props to the Material UI Snackbar component */
  props: PropTypes.any,
};
Notification.defaultProps = {
  message: '',
  autoHideDuration: 3000,
  className: '',
  show: false,
  props: null,
};

export default Notification;
